import { type ReactNode, useCallback, useMemo } from "react";

import { useUserContext } from "@/context/user.context";
import { UserRole } from "@/types/user";

export const useRoleLimitedRender = (allowedRoles: UserRole[]) => {
  const { isInternal, role } = useUserContext();
  const shouldRender = useMemo(() => {
    const roleWithInternal = isInternal ? UserRole.Admin : role;

    return new Set(allowedRoles).has(roleWithInternal);
  }, [allowedRoles, isInternal, role]);

  return useCallback((ui: ReactNode) => shouldRender && ui, [shouldRender]);
};

export const useAdminOnlyRender = () => useRoleLimitedRender([UserRole.Admin]);
